import {memo} from 'react';
import CardPaymentServicesDetails from '../../components/PaymentSystemsRegulator/components/CardPaymentServicesDetails/CardPaymentServicesDetails.js';

const CardPaymentServicesDetailsPage = memo(() => (
  <CardPaymentServicesDetails />
));

export default CardPaymentServicesDetailsPage;
